export default "__VITE_PUBLIC_ASSET__c21f559f__"